<template>
	<div class="callobject">	
		<!-- <pre>{{objData}}</pre> -->
		<!-- <div v-if="bIsLoading && ApiData.length==0">loading...</div> -->
		<div  class="mobilePadding">             
			<div class="flatHeader px-2">				
				<div class="row mx-0 align-items-center">
					<div class="bntGroup">
						<base-button type="primary" class="groupfloor" simple @click="backByHistory()" ><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
					</div>
							
				</div>
			</div>
			<div class="row" v-if="typeof objData[0] != 'undefined'">
				<div class="col-md-12 col-lg-6">
				<card class="collapseArrow">
					<collapse :name="'c-c_'+ objData[0].id" :activeIndex="objTabs.photo==true?0:-1" class="">
						
						<collapse-item @activate="onCollapsePhoto">
							

							<div slot="title" class="col-title">
								<h3>ФОТО ОБЪЕКТА</h3>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="!this.objTabs.photo">открыть</span>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="this.objTabs.photo">скрыть</span>
							</div>
							<SecondObj :objData="objData[0]"/>
						</collapse-item>
						
					</collapse>
				</card>
				</div>
				<div class="col-md-12 col-lg-6">
				<card class="collapseArrow">
					<collapse :name="'c-m_'+ objData[0].id" :activeIndex="objTabs.main==true?0:-1" v-if="typeof objData[0]!='undefined'" class="">
						<collapse-item @activate="onCollapseMain">
							<div slot="title" class="col-title">
								<h3>ID {{objData[0].id}}, {{objData[0].categoryName}}</h3>	
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="!this.objTabs.main">открыть</span>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="this.objTabs.main">скрыть</span>
							</div>
							<SecondObjCC :objData="objData[0]"/>
							<!-- <h4 class="text-success mt-3 text-center mb-0" v-if="objData[0].result_name">Текущая классификация звонка: {{objData[0].result_name}}</h4>	 -->

							<div class="d-flex align-items-center justify-content-center">
								<i class="tim-icons text-warning icon-double-right" style="rotate: 90deg;"></i>
								<h4 class="mt-3 mx-2">Позвоните по объявлению</h4>	
								<i class="tim-icons text-warning icon-double-right" style="rotate: 90deg;"></i>
							</div>

							<div class="callform row align-items-end mx-0">
								<div class="col-sm-6 col-12 pl-sm-0 pr-sm-2 px-0">
									<base-input
											label="Номер телефона"
											name="phone"
											v-model="objData[0].salesAgentPhone"
											placeholder="+79XXXXXXXXX"
											mask="phone"
										>
									</base-input>
								</div>
								<div class="col-sm-6 col-12 pr-sm-0 pl-sm-2 px-0">
									<div class="flatPass-btn">
										<base-button type="success" class="my-0" simple @click="$GVO.Call(objData[0].salesAgentPhone,'CC',objData[0].id)">Позвонить</base-button>
										<!--base-button type="success" simple @click="$GVO.Call('79112223344','CC',objData[0].id)">Позвонить</base-button-->	
									</div>
								</div>
								<p> <i class="tim-icons text-danger icon-alert-circle-exc"></i> Пожалуйста, проверьте соответствие номера телефона с номером на рекламной площадке и, в случае несоответствия, исправьте номер перед звонком</p>

							</div>
							<div class="d-flex align-items-center justify-content-center">
								<i class="tim-icons text-warning icon-double-right" style="rotate: 90deg;"></i>
								<h4 class="mt-3 mx-2">Зафиксируйте результат звонка</h4>	
								<i class="tim-icons text-warning icon-double-right" style="rotate: 90deg;"></i>
							</div>

							<div class="callform addClient mt-1">
								
								<div class="col-md mb-3 px-0">
									<label for="" class="col-form-label">Результат разговора</label>
									<el-select						
										class="col-md px-0 select-primary  overflow-overlay"						
										placeholder="Результат разговора"
										size="large"
										v-model="callResult"
										@change="changeClass"
									>
										<el-option
											class="select-primary long-select"
											v-for="option in masCallResults"
											:key="option.value"
											:label="option.label"
											:value="option.value"
										>
										</el-option>
									</el-select>
									<base-button v-if="callResult != '2' && callResult != '3' && callResult != '12'" type="success" simple @click="SaveClass">Сохранить классификацию</base-button>
								</div>
								
								<div v-if="callResult == '2'" class="addClient">
									<h4 class="mt-1">Добавьте клиента в работу</h4>
									<ReFormPrinter 
									:masFormConfig="masAllFormParams"
									:objSaveApiMethod="currentApiFormMethod"
									:SuccessGo="SuccessGo_ClientAdd" 
									SuccessBtnText="Сохранить" 
									/>
								</div>
								
								<div v-if="callResult == '3'" class="addClient">
									<h4 class="mt-1">Напомнить перезвонить</h4>
									<ReFormPrinter 
									:masFormConfig="masAllFormParams_ReCall" 
									:objSaveApiMethod="currentApiFormMethod"
									:SuccessGo="SuccessGo_ReCall" 
									SuccessBtnText="Сохранить" 
									/>
								</div>
								<div v-if="callResult == '6'" class="addClient">
									<h4 class="mt-1">Отказ от сотрудничества</h4>
									<ReFormPrinter 
									:masFormConfig="masAllFormParams_Reject" 
									:objSaveApiMethod="currentApiFormMethod"
									:SuccessGo="SuccessGo_ReCall" 
									SuccessBtnText="Сохранить" 
									/>
								</div>
								<div v-if="callResult == '4'" class="addClient">
									<h4 class="mt-1">Агент, делится комиссией</h4>
									<ReFormPrinter 
									:masFormConfig="masAllFormParams_AgentComission" 
									:objSaveApiMethod="currentApiFormMethod"
									:SuccessGo="SuccessGo_AgentComission" 
									SuccessBtnText="Сохранить" 
									/>
								</div>
								<div v-if="callResult == '12'" class="addClient">
									<h4 class="mt-1">Добавление в мою базу</h4>
									<ReFormPrinter 
									:masFormConfig="masAllFormParams_addMyBase" 
									:objSaveApiMethod="currentApiFormMethod"
									:SuccessGo="SuccessGo_addMyBase" 
									SuccessBtnText="Сохранить" 
									/>
								</div>
							</div>

						</collapse-item>
					</collapse> 
				</card>
				</div>
					<!-- 
					<collapse :activeIndex="objTabs.map==true?0:-1">
						<collapse-item @activate="onCollapseMap">
							<div slot="title" class="col-title">
								<h3>АДРЕС ОБЪЕКТА</h3>
							</div> 

							<div class="objectAddress mt-5">
								<div class="metro">
									<div class="row flex-nowrap ml-0 mr-2 align-items-top" v-if="typeof objData[0]!='undefined' && objData[0].metroName!=null  && objData[0].metroName!=''">
										<i class="tim-ic ic-metro text-primary mr-1"></i>
										<p>метро {{objData[0].metroName}}, </p>									
									</div> 								
									<div class="row ml-0 mr-2 align-items-center" v-if="typeof objData[0]!='undefined' && objData[0].fromSubway!=null  && objData[0].fromSubway!='' && objData[0].fromSubway !='0.00'">
										<p>{{objData[0].fromSubway}} км</p>									
									</div> 								
								</div>
								<div class="" v-if="typeof objData[0]!='undefined'"><p>{{objData[0].region}}, {{objData[0].address}}</p></div>
							</div>
							<div class="map mt-2">
								
								<div>
									<yandex-map
										:settings="yamap_settings"
										:coords="yamap_coords"
										:zoom="yamap_zoom"
										:scroll-zoom="false"
										:controls="yamap_controls"
										>
									
										<ymap-marker
												:coords="yamap_markers.coords"
												:marker-id="yamap_markers.id"
												marker-type="placemark"
										/>

									</yandex-map>
								</div>
							</div>
						</collapse-item>
					</collapse> -->
					<div class="col-md-12 col-lg-6">
					<card class="collapseArrow">
					
					<collapse :name="'c-c_'+$route.params.obj_id" :activeIndex="objTabs.lenta==true?0:-1" class="">
						<collapse-item :name="'c-c_'+$route.params.obj_id" @activate="onCollapseLenta">
							<div slot="title" class="col-title">
								<h3>ЛЕНТА</h3>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="!this.objTabs.lenta">открыть</span>
								<span class="badge badge-primary badge-simple ml-auto my-auto" v-if="this.objTabs.lenta">скрыть</span>
							</div>
							<ReClientLentaNest :id="$route.params.obj_id" obj="COLD_CALLS"/>
						</collapse-item>
					</collapse>
					</card>
					</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Collapse, CollapseItem } from 'src/components';
import { Select, Option, Tooltip } from "element-ui";	
import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
// import ReFormPrinterOptions from 'src/our_components/FormPrinter/ReFormPrinterOptions.vue';
import ReClientLentaNest from "src/our_components/ReClientLentaNest.vue";
import {eventEmitter} from "src/plugins/globalComponents.js";
import SecondObj from '../our_components/Objects/SecondObj.vue';
import SecondObjCC from '../our_components/Objects/SecondObjCC.vue';

export default {
	name: 'callobject-page',
	components: {
		Collapse,
		CollapseItem,
		[Option.name]: Option,
		[Select.name]: Select,
		[Tooltip.name]: Tooltip,
		ReFormPrinter,
		// ReFormPrinterOptions,
		ReClientLentaNest,
		SecondObj,
		SecondObjCC,
	},
	props: {
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
		// flatPass: {
		// 	type: String,
		// 	default: 'ID 254, 1ккв',
		// },
		// objectPass: {
		// 	type: String,
		// 	default: 'Общая информация',
		// },
		currentTab: {
			type: String,
			default: '',
		}
	},
	data () {
		return {
			ver: 1,
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			masAllFormParams_ReCall: this.currentFormConfig_ReCall(),
			masAllFormParams_Reject: this.currentFormConfig_Reject(),
			masAllFormParams_AgentComission: this.currentFormConfig_AgentComission(),
			masAllFormParams_addMyBase: [],//this.currentFormConfig_addMyBase(),
			//currentApiFormMethod_ReCall: this.currentApiFormMethodComp_ReCall(),
			masCallResults: {
				options: [],
			},
			callResult:'1',
			isShown: false,
			bIsLoading: true,
			objData: [],
			objAgents:[],
			objLenta:[],
			masImgs:'',
			masAgents:[],
			objTabs: {photo: true, main: true, map:true, lenta:true},
			activeItem: null,
			descr: '',

		}
	},
	watch: {
		masCellAgents(newVal, oldVal){
			this.masAgents = newVal;
		}
	},
	computed: {
		masCellAgents: function(){
			let arrAgntParsed = [];
			if(typeof this.objData[0] != 'undefined' && this.objData[0].agents != '') {
				const arrAgnt = "[" + this.objData[0].agents + "]";
				arrAgntParsed = JSON.parse(arrAgnt);
			}
			return arrAgntParsed;
		}

	},
	methods: {		
		currentFormConfig() {
			//return require("src/conf/callsAddClientFormConfig.js").post_config;
			this.$GVO.ApiCall('COLD_CALLS.GET_FORM_ClientAdd',{flt:{}})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					this.masAllFormParams = objApi.config;
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
			return {apiMethod:'COLD_CALLS.INS',apiParam:{iData:[],addData:{obj_id:this.$route.params.obj_id,result_id:this.callResult,result_name:this.$GVO.GetCatValName('cat_coldcall_type', this.callResult)}}};
		},
		currentFormConfig_ReCall() {
			//return require("src/conf/callsCallbackFormConfig.js").post_config;
			this.$GVO.ApiCall('COLD_CALLS.GET_FORM_ReCall',{flt:{}})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					this.masAllFormParams_ReCall = objApi.config;
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentFormConfig_Reject(){
			this.$GVO.ApiCall('COLD_CALLS.GET_FORM_Reject',{flt:{}})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					this.masAllFormParams_Reject = objApi.config;
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentFormConfig_AgentComission(){
			this.$GVO.ApiCall('COLD_CALLS.GET_FORM_AgentComission',{flt:{}})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					this.masAllFormParams_AgentComission = objApi.config;
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentFormConfig_addMyBase(){
			this.$GVO.ApiCall('COLD_CALLS.GET_FORM_addMyBase',{flt:{'cellId':this.objData[0].cellId, 'url':this.objData[0].url, 'rooms':this.objData[0].rooms, 'price': this.objData[0].price}})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					this.masAllFormParams_addMyBase = objApi.config;
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		/*
		currentApiFormMethodComp_ReCall(){
			return {apiMethod:'COLD_CALLS.INSUPD',apiParam:{iData:[],addData:{obj_id:this.$route.params.obj_id,result_id:this.callResult,result_name:this.$GVO.GetCatValName('cat_coldcall_type', this.callResult)}}};
		},
		*/
		changeClass(){
			this.currentApiFormMethod = this.currentApiFormMethodComp();//{apiMethod:'COLD_CALLS.INS',apiParam:{iData:[],addData:{obj_id:this.$route.params.obj_id,result_id:this.callResult,result_name:this.$GVO.GetCatValName('cat_coldcall_type', this.callResult)}}};
		},
		SuccessGo_ClientAdd(evt,dopParam){
			//console.log(evt,dopParam);
			eventEmitter.$emit('reload_lenta');
		},	
		SuccessGo_ReCall(evt,dopParam){
			//console.log(evt,dopParam);
			eventEmitter.$emit('reload_lenta');
		},
		SuccessGo_AgentComission(evt,dopParam){
			//console.log(evt,dopParam);
			eventEmitter.$emit('reload_lenta');
		},
		SuccessGo_addMyBase(evt,dopParam){
			//console.log(evt,dopParam);
			eventEmitter.$emit('reload_lenta');
		},
		SaveClass(){
			this.$GVO.ApiCall('COLD_CALLS.INS',{iData:{obj_id:this.$route.params.obj_id,result_id:this.callResult,result_name:this.$GVO.GetCatValName('cat_coldcall_type', this.callResult)}})
			.then((objApi) => {
				// console.log(objApi.data);
				if(objApi.success === true){ 
					//console.log(objApi.data);
					eventEmitter.$emit('reload_lenta');
				}
			}).catch(errorObjApi => { console.error(errorObjApi); });
		},
		backByHistory(){
			// this.$router.back();
			this.$router.go(-1);
			// console.log(localStorage);
		},
		getObject(){
			// console.log('getObject',this.$route.params.obj_id);
			this.objGetParams = this.$GVO.GetAllGet();
			if(typeof this.$route.params.obj_id != 'undefined'){
				this.$GVO.ApiCall('COLD_CALLS.GET',{flt:{ act:1, obj_id:this.$route.params.obj_id, c2p:1 }})
				.then((objApi) => {
					this.bIsLoading = false;
					// console.log(objApi.data);
					if(objApi.success === true){ 
						//console.log(objApi.data);
						this.objData = this.$GVO.unlinkObject(objApi.data);
						this.currentFormConfig_addMyBase();
					}else{
						this.objData = [];
					} 
				}).catch(errorObjApi => {this.objData = []; console.error(errorObjApi); });
				/*
				this.$GVO.ApiCall('COLD_CALLS.GET',{flt:{act:1,obj_id:this.$route.params.obj_id}})
				.then((objApi) => {
					this.bIsLoading = false;
					console.log(objApi.data);
					if(objApi.success === true){ 
						//console.log(objApi.data);
						this.objData = this.$GVO.unlinkObject(objApi.data);
					}else{
						this.objData = [];
					} 
				}).catch(errorObjApi => {this.objData = []; console.log(errorObjApi); });		
				*/		
			}
		},
		onCollapsePhoto(opt){
			this.objTabs.photo = opt;
			this.saveTabs();
		},
		onCollapseMain(opt){
			this.objTabs.main = opt;
			this.saveTabs();
		},
		onCollapseMap(opt){
			this.objTabs.map = opt;
			this.saveTabs();
		},
		onCollapseLenta(opt){
			this.objTabs.lenta = opt;
			this.saveTabs();
		},
		saveTabs() {
			const parsed = JSON.stringify(this.objTabs);
			localStorage.setItem('objTabs', parsed);
		},
		cleanDescription(descr){
			//console.log(descr);	
			descr = (descr||'').replace(/\u2028/g,' ');
			return descr;
		},	
		// masCellAgents(){
		// 	if(typeof this.objData[0] != 'undefined' && this.objData[0].agents != '') {
		// 		const arrAgnt = "[" + this.objData[0].agents + "]";
		// 		let arrAgntParsed = JSON.parse(arrAgnt);
		// 		// const arrAgnt =  JSON.parse(JSON.stringify(this.objData[0].agents));
		// 		console.log(arrAgntParsed);
				
		// 		// for(let i = 0; i < arrAgntParsed.length; i++){
		// 		// 	for (let value of Object.values(arrAgntParsed[i])) {
		// 		// 		masAgents.push({name: value, id: value});
		// 		// 		console.log(masAgents);
		// 		// 	}
		// 		// }
		// 	}
			
		// 	// return arrAgntParsed;
		// }

	},
	mounted(){
		/*
		if(typeof this.objData != 'undefined'){
			this.yamap_coords = [this.objData[0].houseLat,this.objData[0].houseLng];
			this.yamap_markers.coords = [this.objData[0].houseLat,this.objData[0].houseLng];
		}*/
		// this.masCellAgents();
	},
	created(){
		eventEmitter.$on('reload_lenta', this.getObject);
		this.getObject();
		this.$GVO.LoadCatPromise('cat_coldcall_type').then((ret)=>{
			this.masCallResults = this.$GVO.getCatToSelect('cat_coldcall_type');
		}).catch(errorRet => console.error(errorRet));

		if (localStorage.getItem('objTabs')) {
			try {
				this.objTabs = JSON.parse(localStorage.getItem('objTabs'));
				if(this.$GVO.isEmpty(this.objTabs)){
					this.objTabs = {photo:true,main:true,map:true,lenta:true};
				}
			} catch(e) {
				localStorage.removeItem('objTabs');
			}
		}
		
	},
	beforeDestroy() {
		// Отписываемся от события
		eventEmitter.$off('reload_lenta', this.getObject);
	},
}
</script>
<style scoped>

.callobject {width: 100%;}
.flatHeader {display: flex; padding: 15px; justify-content: space-between; flex-wrap: wrap;}
.flatHeader-btn {display: flex; flex-wrap: wrap;}
.flatTitles {display: flex; flex-direction: column;}
.flatTitles h4 {margin-bottom: 5px;}
.flatPhotos {height: auto; flex-shrink: 0;}
.flatPass {flex-shrink: 2;}
.structure-btns > button {width: 100%;}
.icon-folder {width: 18px; height: 18px; background-image: url('/img/icons/folder.svg'); background-repeat: no-repeat;  margin: 0px 7px 3px 0px;}
.callobject >>> .form-options-group {width: 100%;}
.callobject >>> .bntGroup {display: flex; justify-content: space-around;}
.callobject >>> .map{height: auto;}


/*===collapse===============================*/

.flatPass >>> .card-collapse .card:not(.card-cinc) .card-header {padding-top: 0px;}
.flatPass >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}
.flatPass >>> .card-collapse .card:not(.card-cinc) .card-body {padding-right: 0px; padding-left: 0px;}
.flatPass-container {display: flex; flex-direction: column;}
.flatPass-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.flatPass-btn {display: flex; justify-content: space-between; margin-bottom: 10px; /*margin-top: 10px;*/}
.flatPass-btn > button {width: 100%;}

.flatPass-row h3{margin-bottom: 0px;}


.objectInfo, .priceFlow  {display: flex; justify-content: space-between; flex-wrap: wrap;}
.objectInfo h4:first-child {margin-right: 15px;}
.objectAddress {display: flex; flex-wrap: wrap;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}
.metroIc {margin-right: 7px;}
.metroIc {margin-bottom: 8px;}
.service-title {display: flex; flex-wrap: wrap;}
.marker::before {
	content: "\20DD";
	color: #01B0E0;
	padding-right: 18px;
	font-size: 12px;
	font-weight: normal;
}
.object-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.object-row > p:first-child {min-width: 100px; margin-right: 10px;}
.objectPass-row {display: flex; flex-wrap: wrap; justify-content: flex-end;}
.objectPass-row p {position: relative; padding-left: 10px;}
.objectPass-row p:not(:first-child)::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: 3px;
	top: 9px;
} 
.collapseRegular >>> .card-collapse {border-right: unset!important;}
.collapseRegular >>> .card-collapse .card:not(.card-cinc) .card-header a {
    color: #01B0E0;
}
.collapseRegular >>> .card-header {padding-bottom:0px!important;}
/* .callobject .my-row .card-collapse{
	border-right: 1px solid #01b0e0;
	height: fit-content;
	display: inline-block;
	width: 50%;
	padding: 0px;
} */
.callobject .my-row .collapseArrow{
	/* border-right: 1px solid #01b0e0; */
	height: fit-content;
	display: inline-block;/**/
	width: 49%;
	/* width: 50%; */
	padding: 0px;
}
.callobject >>> .card-collapse[name^="c-"] > .card > .card-header{
	border-bottom: 2px solid #01B0E0;  /*medium вместо 2px,  как красивше*/
	background-color: #01b0e01b!important; 
	box-shadow: 0 9px 7px -3px rgb(158 119 243 / 40%);
}
.callobject >>> .card-collapse[name^="c-"] .card:not(.card-cinc) .card-header a[data-toggle="collapse"] i {bottom: -7px; display: none;}

.callobject .my-row{
	padding: 0px 20px;
}
.callobject >>> .my-float-pin > div:nth-child(2){
	border-right: 0px;
	float: right;
}

.callobject >>> .card-collapse .postForm {
    background: #27293d;
}
.callobject >>> .clientExists {display: none;}
.callobject >>> .form-options .bntGroup > * {width: fit-content;}

.callobject >>> .addClient {border: 1px dashed #ff8d72; border-radius: 6px; padding: 10px 15px;}
.callobject >>> .callform {border: 1px dashed #01B0E0; border-radius: 6px; padding: 10px 15px;}

.callobject >>> .classificationStatus {
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	width: 100%;
    padding: 15px;
    border-radius: 6px;
	background: linear-gradient(90deg, #1d83bd 0%, #00BF9A 100%);
	color: #fff;
}
.callobject >>> .classificationStatus h4{color: #fff;}


@media (max-width: 768px) {	
	.flatPass {margin-top: 20px; padding: 0px 10px 0px 5px!important;}
	.flatPass-btn {flex-wrap: wrap;}
	.flatPass-btn > button:first-child {margin-right: 0px;}
	.calcs {order: 1; margin-bottom: 20px;}
	.banks {order: 2; padding-right: 0px;}
	.monthly-pay h4 {margin-bottom: 0px;}
	.calcs {padding-left: 0px;}
	.bank-header {flex-wrap: wrap;}
	.mortgage-calc .btn, .flatHeader-btn {margin-top: 15px; width: 100%;}
	.flatHeader {padding: 15px 0px;}
	.cell-agent {flex-wrap: wrap;}
	.callobject .my-row .card-collapse{
		border-right: 0px;
		display: block;
		width: 100%;			
	}
	.callobject .my-row > div:nth-child(2){
		float: none;
	}
	.mobilePadding > .card-body {padding: 15px 0;}
	.callobject >>> .card-collapse .card-body {padding: 5px 0;}
	.task-pl-3 {padding-left: 0px;} 
	.callobject >>> .map {display: none;}
	.clientPage .my-row .card-collapse, .clientPage .my-row .collapseArrow{
			border-right: 0px;
			display: block;
			width: 100%;			
		}
}


@media (max-width: 520px){
	.callobject .my-row{
		padding: 0px 8px;
	}
}

</style>
